import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, Validators } from '@angular/forms';

@Directive({
  selector: '[appPhoneNumber]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: PhoneNumberDirective, multi: true }
  ]
})
export class PhoneNumberDirective implements Validator {

  constructor() { }
  validate(control: AbstractControl): { [key: string]: any } {
    const value : string = control.value;

    if(!value) return null;

    let rslt = Validators.pattern(/^[0-9]\d*$/)(control);

    if(rslt) return { 'numbersOnly': true }

    if(value.charAt(0) === "1") {
      return { 'hasCountryCode': true }
    }

    if(value.length != 10) {
      return { 'invalidPhone': true }
    } 
    
  }

}
